import React, { useState, useEffect } from "react";
import { NumberInput } from "../shared";

const LIMIT_FIELDS = [
  { key: "perTransaction", label: "Per transaction", default: 50 },
  { key: "dailyLimit", label: "Daily limit", default: 200 },
  { key: "sessionLimit", label: "Session limit", default: 100 },
  { key: "autoApproveUnder", label: "Auto-approve under", default: 10 },
];

export default function SpendingLimits({ limits, onSave, disabled }) {
  const [values, setValues] = useState({});
  const [dirty, setDirty] = useState(false);

  useEffect(() => {
    if (limits) {
      setValues(limits);
      setDirty(false);
    }
  }, [limits]);

  const handleChange = (key, val) => {
    const next = { ...values, [key]: val };
    setValues(next);
    setDirty(JSON.stringify(next) !== JSON.stringify(limits));
  };

  const handleSave = () => {
    onSave(values);
    setDirty(false);
  };

  return (
    <div className={`mcp-spending-limits ${disabled ? "mcp-disabled-section" : ""}`}>
      <h5 className="mcp-subsection-title">Spending limits</h5>
      <div className="mcp-limits-grid">
        {LIMIT_FIELDS.map((f) => (
          <NumberInput
            key={f.key}
            label={f.label}
            value={values[f.key] ?? f.default}
            onChange={(val) => handleChange(f.key, val)}
            disabled={disabled}
          />
        ))}
      </div>
      <p className="mcp-field-hint">
        Transactions above the auto-approve threshold will require your
        confirmation.
      </p>
      {dirty && (
        <button
          type="button"
          className="fugu--btn mcp-btn-save"
          onClick={handleSave}
        >
          <span>Save</span>
        </button>
      )}
    </div>
  );
}
